(function (angular) {
    angular.module('bizPartEngage').directive('bizMyText', bizMyText);    

    bizMyText.$inject = ["bizCore", "core.users.service"];    

    function bizMyText(bizCore, userService) {
        var directive = {
            restrict: "E",
            scope: {
                settingKey: '@'                
            },
            templateUrl: bizCore.getView('core.directives.mytext', "FrontEnd/Core/Directives/Views/MyText.html"),
            bindToController: true,
            controller: bizMyTextController,
            controllerAs: "vm"            
        }

        bizMyTextController.$inject = ['$mdDialog'];

        function bizMyTextController($mdDialog) {
            var vm = this;

            vm.DefaultData = {
                ImageUrl: '~/Images/mytext-default.png',
                Text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras vulputate sodales consectetur. Proin gravida felis vel dolor ornare, eu cursus est maximus.',
                Color: '#000'
            };                        

            vm.Init = Init;   
            vm.OpenEdit = OpenEdit;            

            function OpenEdit() {
                $mdDialog.show({
                    parent: angular.element(document.body),
                    templateUrl: siteRootPath + "FrontEnd/Core/Directives/Views/MyTextEdit.html",
                    controller: EditDialogController,
                    controllerAs: "vm",                    
                    bindToController: true,                    
                    locals: {
                        settingKey: vm.settingKey,
                        data: angular.copy(vm.Data),
                        settingKey: vm.settingKey
                    }
                }).then(EditClose);

                function EditClose(data) {     
                    if (data) {
                        vm.Data = data;
                    }
                }

                EditDialogController.$inject = ["$mdDialog", "bizMediabankService", "bizCoreService"];

                function EditDialogController($mdDialog, bizMediabankService, bizCoreService) {
                    var vm = this;
                    vm.Save = Save;
                    vm.Cancel = Cancel;

                    vm.Colors = [
                        {
                            Name: 'Svart',
                            Id: '#000'
                        },
                        {
                            Name: 'Vit',
                            Id: '#FFF'
                        }
                    ];

                    vm.selectedColor = vm.Colors.GetItemByValue('Id', vm.data.Color);
                    vm.image = {
                        FileUrl: vm.data.ImageUrl
                    };

                    vm.uploadSettings = {
                        FileType: bizMediabankService.FileTypes.Image,
                        FileLocation: bizMediabankService.UploadLocations.MyText,
                        FilePattern: '',
                        IsPrivate: true,
                        IsInvisible: false,
                        IsPrivateControlHidden: true,
                        IsInvisibleControlHidden: true,
                        IsUser: true
                    };

                    function Save() {
                        vm.data.ImageUrl = vm.image ? vm.image.FileUrl : undefined;
                        vm.data.Color = vm.selectedColor.Id;
                        bizCoreService.UpdateUserSetting(vm.settingKey, JSON.stringify(vm.data)).then(function (response) {
                            $mdDialog.hide(vm.data);
                        });                            
                    }

                    function Cancel() {
                        $mdDialog.hide();
                    }
                }
            }

            function Init() {
                userService.GetLoggedInUserSetting(vm.settingKey).then(GetSettingCallback);

                function GetSettingCallback(response) {                              
                    var data = BizPartCoreHelpers.getResponseValue(response);                    
                    if (data) {
                        vm.Data = JSON.parse(data);
                    } else {
                        vm.Data = vm.DefaultData;
                    }
                }
            }

            vm.$onInit = vm.Init;
        }

        return directive;
    }
       
})(window.angular);
